import React, { ChangeEvent, useRef } from "react"
import { LuPaperclip } from "react-icons/lu";

interface FileUploadButtonProps {
  onFileSelect: (file: File) => void;
}


export const FileButton = ({ onFileSelect }: FileUploadButtonProps) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const selectedFile = files[0];
      onFileSelect(selectedFile);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <input
        type="file"
        accept=".pdf, .doc, .docx, image/*, .mp4" // Defina as extensÃµes de arquivo permitidas
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />

      <button onClick={() => fileInputRef.current?.click()}>
        <LuPaperclip size={14} color={'#696969'} />
      </button>


    </div>
  )
}